const APP_NAME = 'kwerty';
const IS_ADMIN = true;

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';

export { APP_NAME, IS_ADMIN };
